import { render } from "./SignalsView.vue?vue&type=template&id=0cd3a3dc"
import script from "./SignalsView.vue?vue&type=script&lang=js"
export * from "./SignalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__